import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { centerCls } from '@pm2/react-utils';
import { breakpoints } from '@ui/css';
import { PostloadedImage, IsomorphicPortal, ShowFor, CSSRefTransition } from '@utils/react';
import { header, image, heading, subHeading, buttonWrapper, center, mobileButtonWrapper, mobileButtonAppearTransitionDurationMs } from './sticky-header.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function StickyHeader(props) {
  return /*#__PURE__*/jsxs("header", {
    role: "presentation",
    className: header,
    "aria-hidden": true,
    children: [/*#__PURE__*/jsxs("div", {
      className: cx(centerCls, center),
      children: [props.vignetteSrc && /*#__PURE__*/jsx(PostloadedImage, {
        className: image,
        src: props.vignetteSrc,
        sizes: "90px",
        alt: ""
      }), /*#__PURE__*/jsx("h1", {
        className: heading,
        children: props.heading
      }), props.subHeading && /*#__PURE__*/jsx("h2", {
        className: subHeading,
        children: props.subHeading
      }), /*#__PURE__*/jsx("div", {
        className: buttonWrapper,
        children: props.children
      })]
    }), /*#__PURE__*/jsx(IsomorphicPortal, {
      children: /*#__PURE__*/jsx(ShowFor, {
        breakpoint: breakpoints.tablet.andDown(),
        children: /*#__PURE__*/jsx(TransitionGroup, {
          appear: true,
          component: null,
          children: /*#__PURE__*/jsx(CSSRefTransition, {
            timeout: mobileButtonAppearTransitionDurationMs,
            classNames: mobileButtonWrapper,
            children: ref => /*#__PURE__*/jsx("div", {
              ref: ref,
              className: mobileButtonWrapper,
              children: /*#__PURE__*/jsx("div", {
                className: centerCls,
                children: props.children
              })
            })
          })
        })
      })
    })]
  });
}

export { StickyHeader };
//# sourceMappingURL=sticky-header.js.map
